window.addEventListener('load', event => {
    // Desktop nav
    let desktopNavDropdownContent = document.querySelectorAll('.desktop-nav-dropdown-content');

    // Keeps land dropdown nav hidden for 500ms on page load to mask transitions
    for (let navDropdown of desktopNavDropdownContent) {
        setTimeout(function() {
            navDropdown.removeAttribute('style');
        }, 500);
    }
});

window.addEventListener('load', () => {

    // Dropdown Test
    const siteHeader = document.getElementById('siteHeader')
    const offCanvasMenuMobile = document.getElementById('offCanvasMenuMobile');
    const menuToggleMobile = document.getElementById('menuToggleMobile');
    const menuBackdrop = document.getElementById('menuBackdrop');
    let scrollLimit = 500;
    let navOpenScrollPosY = window.scrollY;

    // id for below is retrieved from animated-hamburger.svg
    const hamburger = document.getElementById('ek0RzW3Va4r1');
    // https://www.svgator.com/help/getting-started/svgator-player-js-api
    // ^ related to below svgatorPlayer controls
    const player = hamburger ? hamburger.svgatorPlayer : {};

    if (offCanvasMenuMobile && menuToggleMobile) {
        // measures to stop menu appearing on page load
        offCanvasMenuMobile.removeAttribute('style');

        menuToggleMobile.addEventListener('click', () => {
            navOpenScrollPosY = window.scrollY;

            if (siteHeader.dataset.open === 'false') {
                siteHeader.dataset.open = 'true';
                menuBackdrop.classList.remove('opacity-0', 'pointer-events-none');
            } else {
                siteHeader.dataset.open = 'false';
                menuBackdrop.classList.add('opacity-0', 'pointer-events-none');
            }

            if (hamburger) {
                if (player.play) {
                    if (player.hasEnded || player.isPlaying) {
                        player.reverse();
                    } else {
                        player.play();
                    }
                }
            }

            scrollLimit = (offCanvasMenuMobile.offsetHeight / 3) * 2;
            startListening();
        });
    }

    function closeMobileNav() {
        if (siteHeader.dataset.open === 'true') {
            siteHeader.dataset.open = 'false';
            menuBackdrop.classList.add('opacity-0', 'pointer-events-none');

            if (hamburger) {
                if (player.play) {
                    player.reverse();
                }
            }
        }
    }

    // closes open menus and resets nav to default state
    function closeAllNavs() {
        closeMobileNav();
    }

    function startListening() {
        window.addEventListener('click', clickListener);
        window.addEventListener('resize', resizeListener);
        window.addEventListener('scroll', scrollListener);
    }

    function stopListening() {
        window.addEventListener('click', clickListener);
        window.removeEventListener('resize', resizeListener);
        window.removeEventListener('scroll', scrollListener);
    }

    // Throttle for resize listener to close open menus on page resize
    const closeNavResizeThrottle = _throttle(resizeCloseNav, 50, {leading: true, trailing: true});

    function resizeCloseNav() {
        let windowSize = window.innerWidth;
        const checkWidth = setTimeout(() => {
            if (windowSize !== window.innerWidth) {
                closeAllNavs();
                stopListening();
            }
            clearTimeout(checkWidth);
        }, 50);
    }


    // Debounce for click listener to close open menus if click is not inside menu
    const closeNavClickDebounce = _debounce(clickOutsideCloseNav, 50, {leading: true, trailing: true});

    function clickOutsideCloseNav() {
        if (!document.getElementById('siteHeader').contains(event.target)) {
            closeAllNavs();
            stopListening();
        }
    }


    // Throttle for scroll listener to close open menus if scroll exceeded scroll limit
    const closeNavScrollThrottle = _throttle(scrolledPastLimit, 50, {leading: true, trailing: true});

    function scrolledPastLimit() {
        if (window.scrollY >= (scrollLimit + navOpenScrollPosY) || window.scrollY <= (navOpenScrollPosY - scrollLimit)) {
            closeAllNavs();
            stopListening();
        }
    }

    const clickListener = () => {
        closeNavClickDebounce(event);
    };

    const resizeListener = () => {
        closeNavResizeThrottle();
    };

    const scrollListener = () => {
        closeNavScrollThrottle();
    };
});

// handles home page sticky nav
window.addEventListener('load', event => {

    let homeNavMenu = document.querySelector('[data-nav-top]');

    if (homeNavMenu) {

        let scrollLimit = 20;
        scrolledPastLimit();

        // Throttle for scroll listener to adjust menu styles based on scroll position
        const throttleNavScrollCheck = _throttle(scrolledPastLimit, 50, {leading: true, trailing: true});
        window.addEventListener('scroll', throttleNavScrollCheck, {passive: true});

        function scrolledPastLimit() {
            const scrollTop = document.documentElement.scrollTop;

            if (scrollTop <= scrollLimit) {
                homeNavMenu.dataset.navTop = 'true';
            } else {
                homeNavMenu.dataset.navTop = 'false';
            }
        }
    }
});
